import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = () => {
  const [cartCount, setCartCount] = useState(0);
  const [recentOrders, setRecentOrders] = useState([]);

  useEffect(() => {
    // Load cart count
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      const cartItems = JSON.parse(savedCart);
      setCartCount(cartItems.length);
    }

    // Load recent orders (mock data)
    const mockRecentOrders = [
      { id: 1, date: "2024-01-15", total: 45.99, items: 8 },
      { id: 2, date: "2024-01-10", total: 32.50, items: 5 },
      { id: 3, date: "2024-01-05", total: 78.25, items: 12 }
    ];
    setRecentOrders(mockRecentOrders);
  }, []);

  const quickActions = [
    {
      id: 1,
      title: "View Cart",
      subtitle: `${cartCount} items`,
      icon: "ShoppingCart",
      color: "bg-primary text-primary-foreground",
      link: "/shopping-cart",
      badge: cartCount > 0 ? cartCount : null
    },
    {
      id: 2,
      title: "Reorder Favorites",
      subtitle: "Quick reorder",
      icon: "RotateCcw",
      color: "bg-secondary text-secondary-foreground",
      link: "/product-catalog-category-browse?filter=favorites"
    },
    {
      id: 3,
      title: "Weekly Deals",
      subtitle: "Save up to 30%",
      icon: "Tag",
      color: "bg-accent text-accent-foreground",
      link: "/product-catalog-category-browse?category=deals"
    },
    {
      id: 4,
      title: "Track Orders",
      subtitle: "Order status",
      icon: "Package",
      color: "bg-success text-success-foreground",
      link: "/user-authentication-login-register"
    }
  ];

  return (
    <div className="mb-12">
      <h2 className="font-heading font-heading-semibold text-xl md:text-2xl text-text-primary mb-6">
        Quick Actions
      </h2>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {quickActions.map((action) => (
          <Link
            key={action.id}
            to={action.link}
            className="group bg-surface rounded-card p-4 shadow-card hover:shadow-medium transition-smooth border border-border-light hover:border-primary"
          >
            <div className="text-center">
              <div className="relative inline-block mb-3">
                <div className={`w-12 h-12 rounded-full ${action.color} flex items-center justify-center group-hover:scale-110 transition-smooth`}>
                  <Icon name={action.icon} size={20} />
                </div>
                {action.badge && (
                  <span className="absolute -top-1 -right-1 bg-error text-error-foreground text-xs font-data font-data-medium rounded-full w-5 h-5 flex items-center justify-center">
                    {action.badge > 99 ? '99+' : action.badge}
                  </span>
                )}
              </div>
              <h3 className="font-body-semibold text-sm text-text-primary mb-1 group-hover:text-primary transition-smooth">
                {action.title}
              </h3>
              <p className="font-caption text-xs text-text-secondary">
                {action.subtitle}
              </p>
            </div>
          </Link>
        ))}
      </div>

      {/* Recent Orders Section */}
      {recentOrders.length > 0 && (
        <div className="mt-8 bg-surface rounded-card p-4 shadow-card border border-border-light">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-body-semibold text-lg text-text-primary">
              Recent Orders
            </h3>
            <Link to="/user-authentication-login-register">
              <Button variant="ghost" size="sm" iconName="ArrowRight" iconSize={16}>
                View All
              </Button>
            </Link>
          </div>
          
          <div className="space-y-3">
            {recentOrders.slice(0, 2).map((order) => (
              <div key={order.id} className="flex items-center justify-between p-3 bg-background rounded-input">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                    <Icon name="Package" size={16} color="white" />
                  </div>
                  <div>
                    <p className="font-body-semibold text-sm text-text-primary">
                      Order #{order.id}
                    </p>
                    <p className="font-caption text-xs text-text-secondary">
                      {order.items} items • {new Date(order.date).toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-data font-data-medium text-sm text-primary">
                    ${order.total.toFixed(2)}
                  </p>
                  <Button variant="ghost" size="xs" className="text-xs">
                    Reorder
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickActions;